/** 苗字と名前フォームのクライアント側検証を行う関数 */
export const validateName = (name: string) => {
  if (name === "") {
    return { isError: true, errorText: "必須項目を入力してください" };
  }

  if (name.length > 32) {
    return { isError: true, errorText: "32文字以内で入力してください" };
  }

  return {
    isError: false,
    errorText: "",
  };
};
